document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.component-5050');
  if (!container) return;

  container.addEventListener('click', function (e) {
    const toggle = e.target.closest('.component-accordion-toggle');
    if (!toggle || !container.contains(toggle)) return;

    const contentId = toggle.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    if (!content) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    content.setAttribute('data-hidden', String(expanded));

    // Optional: collapse other open panels
    container.querySelectorAll('.component-accordion-toggle').forEach(btn => {
      if (btn !== toggle) {
        const id = btn.getAttribute('aria-controls');
        const panel = document.getElementById(id);
        if (panel) {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('data-hidden', 'true');
          panel.style.maxHeight = null;
        }
      }
    });
  });

  // Initialize collapsed state
  container.querySelectorAll('.component-accordion-content').forEach(content => {
    content.setAttribute('data-hidden', 'true');
    content.style.maxHeight = null;
  });
});
